var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<br/><div class=\"row\"><retailer-forms retailer-id=\"{{ $ctrl.customer.id }}\" retailer=\"$ctrl.customer\" disable-query-string=\"true\"></retailer-forms></div>";
var id1="cust-details.forms.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;